import type { ReactNode } from 'react';

interface BookingSummaryRowProps {
	label: string;
	value: ReactNode;
	/** Long free text (notes) reads better unbolded. */
	variant?: 'default' | 'normal' | 'positive';
}

/** One label/value pair inside a `.pb__summary` grid. */
const BookingSummaryRow = ({ label, value, variant = 'default' }: BookingSummaryRowProps) => (
	<>
		<span className="pb__summary-label">{label}</span>
		<span
			className={`pb__summary-value${variant !== 'default' ? ` pb__summary-value--${variant}` : ''}`}
		>
			{value}
		</span>
	</>
);

export default BookingSummaryRow;
